import { Href, LoginRoute, ProfileRoute } from "../../utils/Constant";

export const notificationData = [
  {
    img: "wallet.png",
    link: Href,
    title: "New daily offer added",
    subTitle: "New user-only offer added",
    color: "primary",
  },
  {
    img: "shield-dne.png",
    link: Href,
    title: "Product Evaluation",
    subTitle: "Changed to a new workflow",
    color: "info",
  },
  {
    img: "graph.png",
    link: Href,
    title: "Return of a Product",
    subTitle: "452 items were returned",
    color: "warning",
  },
  {
    img: "ticket-star.png",
    link: Href,
    title: "Recently Paid",
    subTitle: "Mastercard payment of $343",
    color: "tertiary",
  },
];

export const messageData = [
  {
    img: "1.png",
    statusClass: "Hello Miss...😊",
    userName: "Hackett Yessenia",
    time: "10 min.",
    color: "primary",
  },
  {
    img: "2.png",
    statusClass: "Wishing You a Happy Birthday Dear.. 🥳🎊",
    userName: "schneider Adan",
    time: "25 min.",
    color: "secondary",
  },
  {
    img: "3.png",
    statusClass: "Hello Dear!! This Theme Is Very beautiful",
    userName: "Mahdi Gholizadeh",
    time: "1 hours",
    color: "success",
  },
];

export interface profilesMessageType {
  name: string;
  icon: "User" | "Mail" | "FileText" | "Settings" | "LogOut";
  link: string;
}

export const profilesMessage: profilesMessageType[] = [
  // {
  //   name: "Account",
  //   icon: "User",
  //   link: `/${ProfileRoute} `,
  // },
  // {
  //     name: "Inbox",
  //     icon:"Mail",
  //     link: `/email/letter_box`
  // },
  // {
  //     name: "Taskboard",
  //     icon:"FileText",
  //     link:`/app/task`
  // },
  {
    name: "Log Out",
    icon: "LogOut",
    link: `/${LoginRoute}`,
  },
];
